// @ts-nocheck
import { createFileRoute } from '@tanstack/react-router';
import CustomerZoneAppointmentListPage from '@/PageComponents/CustomerZone/CustomerZoneAppointment/CustomerZoneAppointmentListPage';

export default CustomerZoneAppointmentListPage;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/appointmentlist')({ component: CustomerZoneAppointmentListPage });
